<template>
  <div v-if="showMenu" class="main-div">
    <Header />
    <div class="content-div">
      <router-view />
    </div>
    <Footer />
  </div>
  <div
    v-else
    class="d-flex align-items-center justify-content-center w-100 center"
  >
    <router-view />
  </div>
  <ModalLoading />
  <ToastGlobal />
</template>

<script lang="ts">
  import Header from '@/components/Organisms/Header.vue'
  import Footer from '@/components/Organisms/Footer.vue'
  import ModalLoading from '@/components/templates/ModalLoading.vue'
  import { defineComponent } from 'vue'
  import { Tooltip } from 'bootstrap'
  import ToastGlobal from './components/templates/ToastGlobal.vue'

  export default defineComponent({
    components: {
      Footer,
      ModalLoading,
      ToastGlobal,
      Header,
    },
    data: () => ({
      hasAr: false,
    }),
    computed: {
      showMenu() {
        return (
          this.$route.name !== 'WithoutRoute' &&
          this.$route.name !== 'Error404' &&
          this.$route.name !== 'BadSproLink'
        )
      },
    },
    created() {
      setTimeout(() => {
        const tooltipTriggerList = document.querySelectorAll(
          '[data-bs-toggle="tooltip"]',
        )
        ;[...tooltipTriggerList].map(
          (tooltipTriggerEl) => new Tooltip(tooltipTriggerEl),
        )
      }, 50)
    },
    beforeCreate() {
      setTimeout(() => {
        const arData = localStorage.getItem('arData')
        if (arData) {
          this.hasAr = true
        }
      }, 1300)
    },
  })
</script>

<style lang="stylus">
  *
    margin: 0
    padding: 0
    box-sizing: border-box

  .center
    height: 100vh

  body
    background-color: #FCFCFC
    overflow-y: auto !important
    height: 100%

  html
    height: 100%

  .main-div
    display: flex
    flex-direction: column
    justify-content: space-between;
    height: 100%

  .content-div
    height: 100%
    height: max-content
    flex-grow: 1

    router-view
      flex-grow: 1
      align-self: start
      height: 100%
      height: max-content

  .modal-dialog {
    z-index: 999999;
  }

  #app
    font-family 'Poppins', Helvetica, Arial, sans-serif
    -webkit-font-smoothing antialiased
    -moz-osx-font-smoothing grayscale
    text-align center
    height: 100%
    overflow-y: auto !important

  .vs__dropdown-toggle
    border: none !important
    padding: 0 !important;

  .vs__actions
    display: none !important
    color: #212529 !important
    padding: 0 !important

  .vs__search
    margin: 0 !important

  .vs__selected
    margin: 0 !important

  .no-options
    display: none

    :root {
      --tooltip-font-size: 1rem;
    }

  .offcanvas
    z-index: 1051

  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.2s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  input:-internal-autofill-selected
    background-color: #FFF !important;

  @media screen and (min-width: 1170px) {
    .container {
      max-width: 1170px !important
    }
  }
</style>
